var React = require('react');

function DroneIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.125 13.125c4.25.93 6.375 1.638 6.375 2.125 0 .487-2.125 1.195-6.375 2.125l-8.5 1.063-3.188 1.062h-1.593l-7.77 9.828h2.656c.93 0 1.395.133 1.395.399 0 .265-.465.398-1.395.398h-7.636v-.797h1.062v-10.89H7.97l-4.45 5.312H1.263l-.73-.73v-4.582h.53v-1.063H4.25v-.2L0 16.646v-2.79l4.25-.53v-.2H1.062v-1.063h-.53V7.48l.73-.73H3.52l4.449 5.313h3.187V1.171h-1.062V.375h7.636c.93 0 1.395.133 1.395.398 0 .266-.465.399-1.395.399h-2.656L22.844 11h1.593l3.188 1.063 8.5 1.062z","fill":"#000"}));
}

DroneIcon.defaultProps = {"width":"43","height":"31","fill":"#000"};

module.exports = DroneIcon;

DroneIcon.default = DroneIcon;
